import { ArrowLeft } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <section className="not-found section-shell">
      <p className="section-kicker">Page not found</p>
      <h1>This path does not lead anywhere yet.</h1>
      <p>Return to the site or tell us about the project you came here to solve.</p>
      <div><Link className="button button--secondary" to="/"><ArrowLeft aria-hidden="true" size={18} /> Back Home</Link><Link className="button button--primary" to="/contact">Request an Estimate</Link></div>
    </section>
  );
}

